import { Badge, type BadgeTone } from '@/components/ui/badge'

import { StockTransactionModel } from '@/types'

export const getTypeBadge = (type: StockTransactionModel.StockTransaction['type']) => {
  const tone: Record<string, BadgeTone> = {
    purchase: 'info',
    adjustment: 'orange',
    transfer: 'soft',
  }
  const label = { purchase: 'Purchase', adjustment: 'Adjustment', transfer: 'Transfer' }
  return <Badge tone={tone[type] ?? 'soft'}>{label[type] ?? type}</Badge>
}

export const getStatusBadge = (status: StockTransactionModel.StockTransaction['status']) => {
  const tone: Record<string, BadgeTone> = {
    completed: 'success',
    pending: 'warning',
    cancelled: 'error',
  }
  const label = { completed: 'Completed', pending: 'Pending', cancelled: 'Cancelled' }
  return <Badge tone={tone[status] ?? 'soft'}>{label[status] ?? status}</Badge>
}

export const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
